<template>
  <div class="policy-list">
    <div class="policy-grid">
      <div 
        v-for="item in list" 
        :key="item.url" 
        class="policy-item"
        @click="$emit('item-click', item.url)"
      >
        <div class="policy-content">
          <span class="policy-title">{{ item.title }}</span>
          <span class="policy-date">{{ item.date }}</span>
        </div>
        <!-- <RightOutlined class="policy-arrow" /> -->
      </div>
    </div>
  </div>
</template>

<script>
// import { RightOutlined } from '@ant-design/icons-vue'

export default {
  name: 'PolicyList',
  components: {  },
  props: {
    list: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
.policy-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px; 
}

.policy-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  cursor: pointer;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  transition: all 0.3s;
}

.policy-item:hover {
  background-color: #f5f5f5;
  border-color: #d9d9d9;
}

.policy-content {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
}

.policy-title {
  display: -webkit-box;
  -webkit-line-clamp: 1; 
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis; 
}

.policy-date {
  margin-left: 15px;
  color: #888;
  font-size: 0.9em;
  white-space: nowrap;
}

.policy-arrow {
  color: #bfbfbf;
  margin-left: 16px;
}

/* 响应式设计，在小屏幕上改为单列 */
@media (max-width: 768px) {
  .policy-grid {
    grid-template-columns: 1fr;
  }
}
</style>